//added to fix webpack error on web
export const rNFetchBlob = undefined